export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8598.6b972315.jpg";